// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"562a1530","968":"15b79a76"}[chunkId] + ".chunk.js";
};